

import * as Configuration from '../../../app.constants.js';

export class ApplicationsService {
  constructor($http, DropdownItemsFactory, $translate) {
    this.$http = $http;
    this.DropdownItemsFactory = DropdownItemsFactory;
    this.$translate = $translate;
  }

  _applicationsURL(companyId) {
    return Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/applications';
  }

  getApplications(companyId) {
    return this.$http.get(this._applicationsURL(companyId));
  }

  createApplication(companyId) {
    return this.$http.post(this._applicationsURL(companyId));
  }

  getApplication(companyId, applicationId) {
    return this.$http.get(this._applicationsURL(companyId) + '/' + applicationId);
  }

  getSubbotClientApplicationList(companyId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/subbot-clients');
  }

  deleteApplication(companyId, applicationId) {
    return this.$http.delete(this._applicationsURL(companyId) + '/' + applicationId);
  }

  updateApplication(companyId, application) {
    const applicationForBackend = {
      name: application.name,
      is_active: application.is_active,
      permissions: angular.copy(application.permissions)
    };
    applicationForBackend.permissions.forEach(permission => {
      // the backend doesn't accept extra fields
      delete permission.label;
      delete permission.tooltip;
    });
    return this.$http.put(this._applicationsURL(companyId) + '/' + application.id, applicationForBackend);
  }

  static ApplicationsFactory($http, DropdownItemsFactory, $translate) {
    return new ApplicationsService($http, DropdownItemsFactory, $translate);
  }
}

ApplicationsService.ApplicationsFactory.$inject = ['$http', 'DropdownItemsFactory', '$translate'];

